import React from 'react';
import ProgramLogo from '../../../../../../hoc/components/logo/program-logo';
import RichText from '../../../../../../hoc/components/rich-text';

const HeaderTop: React.FC<{ title: string }> = ({ title }) => {
	return (
		<>
			<ProgramLogo />
			{title && <p className="max-w-xl m-auto lg:text-center text-2xl"><RichText html={title} /></p>}
		</>
	);
};

export default HeaderTop;
